import { configureStore } from "@reduxjs/toolkit";
import { userReducer } from "./reducers/user";
import { sellerReducer } from "./reducers/seller";
import { deliveryUserReducer } from "./reducers/deliveryUser";
import { productReducer } from "./reducers/product";
import { eventReducer } from "./reducers/event";
import { cartReducer } from "./reducers/cart";
import { wishlistReducer } from "./reducers/wishlist";
import { orderReducer } from "./reducers/order";
import { orderStatusReducer } from "./reducers/orderStatus";
import mapReducer from './reducers/mapReducer';

const Store = configureStore({
  reducer: {
    // user: userReducer,
    // seller: sellerReducer,
    deliveryUser: deliveryUserReducer,
    // products: productReducer,
    // events: eventReducer,
    cart: cartReducer,
    // wishlist: wishlistReducer,
    order: orderReducer,
    map: mapReducer,
    orderStatus: orderStatusReducer
  },
});

export default Store;
